import React from 'react'
import RichTextEditor from '../../components/TextEditor'
function Policy() {
  return (
    <div className="p-[25px] rounded-md border-[solid] border bg-white">
        <h3 className="font-medium">Add New Policy</h3>
      <p className='text-sm text-[#595858] mt-2'>In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without relying on meaningful content. </p>
        <RichTextEditor/>
    </div>
  )
}

export default Policy